export const selectFakeUsersState = (state) => state.fakeUsers;
export const presetsState = (state) => state.presets;
